import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GestionnaireService {
  private host: string = environment.apiUrl;

  constructor(private http: HttpClient) {}

  private authHeaders() {
    const token = localStorage.getItem('tokenConnectedUserWSU1234567GHTVB');
    return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': token });
  }

  getUtilisateurGestionnaire() {
    const username = localStorage.getItem('usernameThatUserIsNowConnect2345789');
    return this.http.get(this.host + "/gestionnaire/liste/utilisateur/" + username, { headers: this.authHeaders() });
  }
}
